import React, { useEffect, useState } from 'react';
import {
  Snackbar,
  Paper,
  Typography,
  Box,
  Slide,
  IconButton,
} from '@mui/material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import CloseIcon from '@mui/icons-material/Close';

function CustomSnackbar({ customopen, setOpenCustomSnackbar, snackbarMessage, role }) {
  console.log(customopen,"customopen")
  const isSuperAdmin = role === 'SUPER_ADMIN';
  const isAdmin = role === 'admin';
  const [state,setstate] = useState(false)


  useEffect(()=>{
    console.log("useeefect")
    console.log(state)
setstate(customopen)
  },[customopen])
  const getStylesByRole = () => {
    if (isSuperAdmin) {
      return {
        bgColor: '#0f172a',
        borderColor: '#facc15',
        icon: <VerifiedUserIcon sx={{ color: '#facc15', fontSize: 28 }} />,
        title: 'Super Admin Message',
        urgent: true,
      };
    }
    if (isAdmin) {
      return {
        bgColor: '#1e40af',
        borderColor: '#60a5fa',
        icon: <AdminPanelSettingsIcon sx={{ color: '#60a5fa', fontSize: 26 }} />,
        title: 'Admin Message',
        urgent: true,
      };
    }
    return {
      bgColor: '#334155',
      borderColor: '#94a3b8',
      icon: null,
      title: 'New Message',
      urgent: false,
    };
  };

  const { bgColor, borderColor, icon, title, urgent } = getStylesByRole();

  return (
    <Snackbar
      open={state}
      autoHideDuration={100000}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      TransitionComponent={(props) => <Slide {...props} direction="down" />}
    >
      <Paper
        elevation={8}
        sx={{
          p: 2,
          backgroundColor: bgColor,
          color: '#fff',
          borderLeft: `6px solid ${borderColor}`,
          display: 'flex',
          alignItems: 'flex-start',
          gap: 2,
          minWidth: 400,
          borderRadius: 2,
          boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
        }}
      >
        {icon}
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="subtitle1" fontWeight={700} fontSize={16}>
            {title}
          </Typography>
          <Typography variant="body2" fontSize={14}>
            {snackbarMessage}
          </Typography>
          {urgent && (
            <Typography
              variant="caption"
              fontWeight={600}
              sx={{ mt: 1, color: '#facc15' }}
            >
              ⚠️ Please respond quickly. Late replies may be considered delayed.
            </Typography>
          )}
        </Box>
<IconButton
  onClick={() => {
    setOpenCustomSnackbar((prev) => {
      console.log('Snackbar close button clicked. Previous state:', prev);
      return false;
    });
  }}
  sx={{ color: '#fff' }}
>
  <CloseIcon />
</IconButton>


      </Paper>
    </Snackbar>
  );
}

export default CustomSnackbar;
